import { useFeatureToggle } from '@flopflip/react-redux';

import { FeatureFlag } from 'constants/featureFlags';

import useEditorOverride from '../useEditorOverride';

const useIsPrismFormEditorRequested = (isTemplateSavedInPrism = false) => {
  const isPrismFlagEnabled = useFeatureToggle(FeatureFlag.EnablePrismFormEditor);
  const editorOverride = useEditorOverride();

  return editorOverride ?? (isTemplateSavedInPrism || isPrismFlagEnabled);
};

export default useIsPrismFormEditorRequested;
